(() => {
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const syncVideo = (video) => {
    if (mediaQuery.matches) {
      video.pause();
      video.removeAttribute('autoplay');
      return;
    }

    video.setAttribute('autoplay', '');
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
  };

  const initialize = () => {
    const videos = document.querySelectorAll('[data-cozy-home-banner-video]');
    if (!videos.length) return;

    videos.forEach((video) => {
      const media = video.closest('.cz-home-campaign-video');
      const showPoster = () => media?.classList.add('is-video-unavailable');
      video.addEventListener('error', showPoster);
      if (video.error) showPoster();
      syncVideo(video);
    });

    const resync = () => videos.forEach(syncVideo);
    if (typeof mediaQuery.addEventListener === 'function') mediaQuery.addEventListener('change', resync);
    else mediaQuery.addListener(resync);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
